import { t } from "@/i18n-js/instance";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { SkeletonLoader } from "@circle-react-shared/uikit/SkeletonLoader";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface DiscountLineProps {
  className?: string;
}

export const DiscountLine = ({ className }: DiscountLineProps) => {
  const { previewMutation } = usePaywallCheckoutContext();

  const preview = previewMutation.data;

  if (!preview || previewMutation.isLoading) {
    return <SkeletonLoader variant="row" lg className={className} />;
  }

  if (preview.first_payment.discount >= 0 || preview.trial_period?.free) {
    return null;
  }

  const amountDiscounted = formatPaywallCurrencyAmount(
    preview.currency,
    preview.first_payment.discount * -1,
  );

  return (
    <div
      className={classNames(
        "text-right first:w-full first:text-right",
        className,
      )}
    >
      <Typography.LabelXs weight="medium" color="text-green-success">
        {t("total_savings_today", {
          formatted_discount: amountDiscounted,
        })}
      </Typography.LabelXs>
    </div>
  );
};
